<template>
  <section>
    <gs-header title="Quản lý quận huyện">
      <router-link :to="{ name: 'create-district' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="districtTable" :table-name="districtTable" data-source="districts" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row>
            <el-col :span="6">
              <el-select v-model="filters.city_id" filterable placeholder="Chọn tỉnh thành" @change="filter"
                class="width-100">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[districtTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[districtTable].current_page - 1) *
                    dataPaginations[districtTable].per_page)}}</small>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="Tỉnh thành"
              width="100"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{scope.row.id}}</span></p>
              </template>
            </el-table-column> -->

            <el-table-column label="Tên" width="350">
              <template slot-scope="scope">
                <p>{{ scope.row.fullname }}</p>
                <p>Tên viết tắt: {{ scope.row.short_name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Loại Quận Huyện" width="245">
              <template slot-scope="scope">
                <p><span class="text-bold">Loại Quận Huyện Đi:</span> {{ scope.row.kind_from_txt }}</p>
                <p><span class="text-bold">Loại Quận Huyện Đến:</span> {{ scope.row.kind_to_txt }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Mã Bưu Chính">
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{ scope.row.code }}</span></p>
              </template>
            </el-table-column>

            <el-table-column v-for="(carrier, index) in listCarriers" :key="index" :label="carrier.name">
              <template slot-scope="scope">
                <p><span class="shipment-code-display text-normal-case">{{ scope.row[carrier.key] }}</span></p>
              </template>
            </el-table-column>


            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline" v-if="!scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer"
                      @click.prevent="detailDistrict(scope.row)"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block cursor-pointer"
                      :to="{ name: 'edit-district', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteDistrict(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="'Chi tiết quận huyện: ' + district.name" :visible.sync="detailModal" width="90%">
        <el-row>
          <el-col :span="24">
            <p class="margin-sm-top margin-sm-bottom">Mã bưu chính: <span class="text-blue text-bold">{{ district.code
                }}</span>
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã giao hàng nhanh: <span class="shipment-code-display">{{
              district.code_ghn }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã VTP: <span class="shipment-code-display">{{ district.code_vtp
                }}</span>
            </p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã Ninja Van: <span class="shipment-code-display">{{
              district.code_njv
                }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã Kerry: <span class="shipment-code-display">{{
              district.code_kerry
                }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Loại quận huyện đi: <span>{{ district.kind_from_txt }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Loại quận huyện đến: <span>{{ district.kind_to_txt }}</span></p>
          </el-col>
        </el-row>
        <el-table v-if="district.carriers" :data="district.carriers.data">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column property="name" label="Tên">
          </el-table-column>
          <el-table-column property="kind_from_txt" label="Loại quận huyện đi">
          </el-table-column>
          <el-table-column property="kind_to_txt" label="Loại quận huyện đến">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { deleteDistrict, restoreDistrict } from 'src/api/district'
import { listCarriers } from 'src/stubs/carriers'
export default {
  name: 'District',
  data() {
    return {
      districtTable: 'districts',
      filters: {
        city_id: '',
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      detailModal: false,
      listCarriers: listCarriers
    }
  },
  computed: {
    ...mapGetters('city', ['city', 'cities']),
    ...mapGetters('district', ['district'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getDistrict', 'setDistrict']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.districtTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.districtTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        city_id: '',
        sort: 'created_at:-1'
      })) {
        this.reloadGsTable(this.districtTable)
      }
      this.filters = {
        city_id: '',
        sort: 'created_at:-1'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteDistrict(district) {
      this.setDistrict(district)
      this.$confirm(`Bạn chắc chắn muốn xóa quận huyện ${this.district.name}`, 'Xóa quận huyện', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delDistrict()
      }).catch(() => {

      })
    },
    delDistrict() {
      deleteDistrict(this.district.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa quận huyện thành công'
          })
          this.reloadGsTable(this.districtTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa quận huyện thất bại'
          })
        }
      })
    },
    detailDistrict(district) {
      this.detailModal = true
      this.getDistrict({ id: district.id, params: { include: 'carriers' } })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(district) {
      this.setDistrict(district)
      this.$confirm(`Bạn chắc chắn muốn khôi phục quận huyện ${this.district.name}`, 'Khôi phục quận huyện', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resDistrict()
      }).catch(() => {

      })
    },
    resDistrict() {
      restoreDistrict(this.district.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục quận huyện thành công'
          })
          this.reloadGsTable(this.districtTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục quận huyện thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.districtTable]) {
      this.filters = ls.get('filters')[this.districtTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.districtTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['districts']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// District.vue?436af4ed